import { useImperativeHandle, useState } from 'react';

import { type InputProps } from 'antd'

import { CarouselProps } from '@widget/airdrop/components/Carousel';

// import { getGreeting } from '@widget/airdrop/constants';
import { items } from './config';
export const useSelectBox = (params) => {
  const { ref } = params;
  const [box, setBox] = useState(items[0].animationInfo.name);
  const [greeting, setGreeting] = useState('');
  useImperativeHandle(ref, () => ({
    cover: box,
    greeting
  }))

  const updateInput: InputProps['onChange'] = (e) => {
    setGreeting(e.target.value);
    setBox(box);
  }
  const updateBox: CarouselProps['onChange'] = (e) => {
    setBox(e.animationInfo.name);
    // setGreeting(greetingMap[e.animationInfo.name])
  }
  return {
    greeting,
    box,
    updateInput,
    updateBox
  }
}
